import { SearchResultPrice } from '@/scopes/search/search/infrastructure/api/types'
import {
  AccommodationService,
} from '@/scopes/search/search/pages/SearchPage/components/Results/Result'

export function getAccommodationServices(translations: Record<string, string>, formatter: (value: number) => string, price?: SearchResultPrice): AccommodationService[] {
  if (!price?.includedServices)
    return []

  const { includedServices, skiPassPublicPrice } = price
  const services: AccommodationService[] = []

  if ('carrental' in includedServices) {
    services.push({ key: 'carrental', icon: 'CarRight', text: includedServices.carrental || '' })
  }

  if ('transfer' in includedServices) {
    services.push({ key: 'transfer', icon: 'BusFront', text: includedServices.transfer || '' })
  }

  if ('skimaterial' in includedServices || 'skipass' in includedServices) {
    const text = `${translations.free} ${'skimaterial' in includedServices ? translations.skimaterial : ''}${
      'skimaterial' in includedServices && 'skipass' in includedServices ? translations.and : ''
    }${'skipass' in includedServices ? translations.skipass : ''}${
      skiPassPublicPrice ? ` ${translations.skipassPrice} ${formatter(skiPassPublicPrice)}` : ''
    }`

    services.push({ key: 'skipass', icon: 'SkiPass', text })
  }

  return services
}
